import { GROWTH_OVERVIEW_QUERY_KEY, type GrowthOverviewGranularity, type GrowthOverviewSortBy } from "../const";

import type { IGrowthOverviewPaginationParams } from "./clampPaginatedGrowthOverviewResponse";

export interface IGrowthOverviewRootQueryKeyParams {
    granularity: GrowthOverviewGranularity;
    sortBy: GrowthOverviewSortBy;
    search?: string;
    category?: string;
    country?: number;
    duration?: string;
    webSource?: string;
    comparedDuration?: string;
    includeSubdomains?: boolean;
    rootPaginationParams: IGrowthOverviewPaginationParams;
}

export const buildGrowthOverviewRootQueryKey = ({
    granularity,
    sortBy,
    search,
    category,
    country,
    duration,
    webSource,
    comparedDuration,
    includeSubdomains,
    rootPaginationParams,
}: IGrowthOverviewRootQueryKeyParams) =>
    [
        GROWTH_OVERVIEW_QUERY_KEY,
        granularity,
        sortBy,
        search,
        category,
        country,
        duration,
        webSource,
        comparedDuration,
        includeSubdomains,
        rootPaginationParams,
    ] as const;
